import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/index.css';
import "react-loading-skeleton/dist/skeleton.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);